import store from "assets/js/store";
import _ from "lodash";

export const getAttributeValueBasedOnType = (value) => {
    if (!value) {
        return "text";
    }
    if (!isNaN(value) && value !== '') {
        return "integer";
    }
    value = value.toLowerCase();
    const regexSystemDates = /^\d+\s(month|year|week|second|day|hour|minute)$/;
    const isDateTime = value.includes("time.parse(") || regexSystemDates.test(value) || value.includes("sys.now");
    if (isDateTime) {
        return "datetime";
    }

    return "text";
};

export const getSelectedAttributesValuesOp = (
    evaluatingSubAutomationName,
    value
) => {
    switch (evaluatingSubAutomationName) {
        case "evaluate_all_condition_on_text":
        case "evaluate_all_not_condition_on_text":
            {
                const startsWithAnyMatch = value.startsWith(".*");
                const endsWtihAnyMatch = value.endsWith(".*");
                if (startsWithAnyMatch && !endsWtihAnyMatch) {
                    return "&end";
                }
                if (startsWithAnyMatch && endsWtihAnyMatch) {
                    if (
                        evaluatingSubAutomationName == "evaluate_all_not_condition_on_text"
                    )
                        return "&like";
                    if (evaluatingSubAutomationName == "evaluate_all_condition_on_text")
                        return "&unlike";
                }
                if (!startsWithAnyMatch && endsWtihAnyMatch) {
                    return "&start";
                }
                if (!startsWithAnyMatch && !endsWtihAnyMatch) {
                    if (
                        evaluatingSubAutomationName == "evaluate_all_not_condition_on_text"
                    )
                        return "eq";
                    if (evaluatingSubAutomationName == "evaluate_all_condition_on_text")
                        return "ne";
                }
            }
            break;
        case "evaluate_all_gt_condition_number":
        case "evaluate_all_not_gt_condition_number":
            return "gt";
        case "evaluate_all_lt_condition_number":
        case "evaluate_all_not_lt_condition_number":
            return "lt";

        default:
            break;
    }
};
export const getSelectedTagsValue = (evaluatingSubAutomationName) => {
    switch (evaluatingSubAutomationName) {
        case "evaluate_all_values_in_list":
            return "noTag";
        case "evaluate_all_not_values_in_list":
            return "hasTag";

        default:
            break;
    }
};

export const removeRegexCharsForOneValue = (value) => {
    let updatedValue = value;
    const startsWithAnyMatch = value ? value.startsWith("*") : "";
    const endsWtihAnyMatch = value ? value.endsWith("*") : "";
    if (startsWithAnyMatch || endsWtihAnyMatch) {
        updatedValue = updatedValue.replaceAll("*", "");
    }
    if (updatedValue)
        if (updatedValue.startsWith("^"))
            updatedValue = updatedValue.replace("^", "");
    if (updatedValue)
        if (updatedValue.endsWith("$"))
            updatedValue = updatedValue.replace("$", "");

    const isDateTime = value ? value.startsWith("${time.parse(\"") : "";
    if (isDateTime)
        updatedValue = updatedValue
            .replace("${time.parse(\"", "")
            .replace("\")}", "");
    const isInteger = value ? value.startsWith("${int(\"") : "";
    if (isInteger)
        updatedValue = updatedValue.replace("${int(\"", "").replace("\")}", "");
    // need to remove the escape characters
    updatedValue = updatedValue.replaceAll("\\", "");
    return updatedValue;
};
export const removeRegexChars = (values) => {
    return values.map((value) => {
        let updatedValue = value;
        const startsWithAnyMatch = value ? value.startsWith(".*") : "";
        const endsWtihAnyMatch = value ? value.endsWith(".*") : "";
        if (startsWithAnyMatch || endsWtihAnyMatch) {
            updatedValue = updatedValue.replaceAll(".*", "");
        }
        if (updatedValue)
            if (updatedValue.startsWith("^"))
                updatedValue = updatedValue.replace("^", "");
        if (updatedValue)
            if (updatedValue.endsWith("$"))
                updatedValue = updatedValue.replace("$", "");

        const isDateTime = value ? value.startsWith("${time.parse(\"") : "";
        if (isDateTime)
            updatedValue = updatedValue
                .replace("${time.parse(\"", "")
                .replace("\")}", "");
        const isInteger = value ? value.startsWith("${int(\"") : "";
        if (isInteger)
            updatedValue = updatedValue.replace("${int(\"", "").replace("\")}", "");
        // need to remove the escape characters
        updatedValue = updatedValue.replaceAll("\\", "");
        return updatedValue;
    });
};

export const getContactDetailsEvaluationSubAutomationName = (
    op,
    attribute,
    invert
) => {
    if (invert)
        switch (op) {
            case "eq":
            case "&like":
            case "&start":
            case "&end":
                return "evaluate_all_not_condition_on_text";
            case "ne":
            case "&unlike":
                return "evaluate_all_condition_on_text";
            case "gt":
                if (attribute.type) {
                    if (attribute.type == "integer" || attribute.type == "datetime") {
                        return "evaluate_all_not_gt_condition_number";
                    }
                } else {
                    const type = store
                        .getState()
                        .attributes.data.filter(
                            (att) => att.name == attribute.name
                        )[0].type;
                    if (type == "integer" || type == "datetime") {
                        attribute.type = type;
                        return "evaluate_all_not_gt_condition_number";
                    }
                }
                break;
            case "lt":
                if (attribute.type == "integer" || attribute.type == "datetime") {
                    return "evaluate_all_not_lt_condition_number";
                }
        }
    else {
        switch (op) {
            case "eq":
            case "&like":
            case "&start":
            case "&end":
                return "evaluate_all_condition_on_text";
            case "ne":
            case "&unlike":
                return "evaluate_all_not_condition_on_text";
            case "gt":
                if (attribute.type) {
                    if (attribute.type == "integer" || attribute.type == "datetime") {
                        return "evaluate_all_gt_condition_number";
                    }
                } else {
                    const type = store
                        .getState()
                        .attributes.filter((att) => att.name == attribute.name)[0].type;
                    if (type == "integer" || type == "datetime") {
                        attribute.type = type;
                        return "evaluate_all_gt_condition_number";
                    }
                }
                break;
            case "lt":
                if (attribute.type == "integer" || attribute.type == "datetime") {
                    return "evaluate_all_lt_condition_number";
                }
        }
    }
};
export const getContactDetailsTagEvaluationSubAutomationName = (
    type,
    invert
) => {
    if (invert)
        switch (type) {
            case "hasTag":
                return "evaluate_all_not_values_in_list";
            case "noTag":
                return "evaluate_all_values_in_list";
        }
    else {
        switch (type) {
            case "hasTag":
                return "evaluate_all_values_in_list";
            case "noTag":
                return "evaluate_all_not_values_in_list";
        }
    }
};
export const escapeSpecialChars = (str) => {
    return _.escapeRegExp(str);
};
export const formatRegex = (op, str) => {
    switch (op) {
        case "eq":
        case "ne":
            return "^" + escapeSpecialChars(str) + "$";
        case "&like":
        case "&unlike":
            return ".*" + escapeSpecialChars(str) + ".*";
        case "&start":
            return "^" + escapeSpecialChars(str) + ".*";
        case "&end":
            return ".*" + escapeSpecialChars(str) + "$";
    }
};
export const formatIntValues = (op, value) => {
    switch (op) {
        case "eq":
        case "ne":
            return "^" + value + "$";
        default:
            return `\${int("${value}")}`;
    }
};
